import { useState, useEffect } from "react";
import { fetchPublicFreeBundles } from "../services/freeBundleService";

export const PLAN_EMOJI = {
  GROUP: "🧑🤝🧑",
  ONE_ON_ONE: "👤",
  PARTNER_PRACTICE: "🤝",
};

const useFreeBundles = () => {
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPublicFreeBundles()
      .then((data) => setBundles(Array.isArray(data) ? data : []))
      .catch(() => setBundles([]))
      .finally(() => setLoading(false));
  }, []);

  return { bundles, loading };
};

export default useFreeBundles;
